const MagazzinoFornitore = () => import('./MagazzinoFornitore')
const FornitoriAttivi = () => import('./FornitoriAttivi')

import store from "../../store"
import { supplierRouteDecision } from "./supplierAccess.mjs"

const ifAuthenticated = (to, from, next) => {
    next(supplierRouteDecision(store.getters.isLoggedIn, store.state.user.userdata, true))
}

const ifInternal = (to, from, next) => {
    const decision = supplierRouteDecision(store.getters.isLoggedIn, store.state.user.userdata)
    next(decision && typeof decision === "object" ? {...decision, query: to.query, hash: to.hash} : decision)
}

export default [
    // Compatibility only: supplier pages belong exclusively to the Fornitori menu.
    {
        path: "/magazzino/fornitori/",
        redirect: to => ({ name: "Fornitori", query: to.query, hash: to.hash }),
    },
    {
        path: "/magazzino/fornitore/:codice",
        redirect: to => ({ name: "fornitori-attivo", params: to.params, query: to.query, hash: to.hash }),
    },
    {
        path: "/magazzino/fornitore_consegnabili/:codice",
        name: "fornitori-consegnabili",
        redirect: to => ({
            name: "fornitori-attivo",
            params: { codice: to.params.codice },
            query: { ...to.query, view: "ready" },
            hash: to.hash,
        }),
    },
    {
        path: "/magazzino/fornitore_riepilogo/:codice",
        name: "fornitori-riepilogo",
        redirect: to => ({
            name: "fornitori-attivo",
            params: { codice: to.params.codice },
            query: { ...to.query, view: "summary" },
            hash: to.hash,
        }),
    },
    {
        path: '/fornitori', name: 'Fornitori',
        meta: {menu: 'fornitore', title: 'Fornitori'},
        component: FornitoriAttivi, beforeEnter: ifInternal,
    },
    {
        path: '/fornitori/:codice', name: 'fornitori-attivo',
        meta: {menu: 'fornitore', title: 'Dettaglio fornitore'},
        component: MagazzinoFornitore, beforeEnter: ifInternal,
    },
    {
        path: '/fornitore/magazzino',
        name: 'fornitore-magazzino',
        meta: {menu: 'fornitore', title: 'Area fornitore'},
        component: MagazzinoFornitore,
        beforeEnter: ifAuthenticated,

    },
    {
        path: '/fornitore/riepilogo',
        name: 'fornitore-riepilogo',
        meta: {menu: 'fornitore', title: 'Riepilogo Fornitore'},
        redirect: {name: 'fornitore-magazzino', query: {view: 'summary'}},
        beforeEnter: ifAuthenticated,

    },
]
